import { render, staticRenderFns } from "./index.vue?vue&type=template&id=445c2611&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style/index.css?vue&type=style&index=0&id=445c2611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c2611",
  null
  
)

export default component.exports